import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseNestService from "../../services/caseNestService";

const useCaseTypes = (caseId) => useQuery([queryKeys.caseTypes, caseId], () => caseNestService.fetchCaseTypes(caseId));

export default useCaseTypes;
